import { RouteConfig } from "vue-router";
import { REmployerRoleTemplate } from "@/pages/Layout/views/Employer/views/Roles/views/template/REmployeRoleTemplate";
import { REmployerRolesBrowse } from "@/pages/Layout/views/Employer/views/Roles/views/browse/REmployerRolesBrowse";

export const REmployerRoles: RouteConfig = {
  path: "roles",
  component: () =>
    import(
      /* webpackChunkName: "employer-roles" */
      "./VEmployerRoles.vue"
    ),
  meta: {
    title: "Job templates",
    icon: "list-outline",
    newIcon: "template",
    hideToolbar: true,
    isChild: true,
  },
  children: [REmployerRolesBrowse, REmployerRoleTemplate],
};
